export const routes = {
  auth: {
    landing: "/",
    login: "/login",
    register: "/register/:programTypeId/:departmentId",
    forgotPassword: "/forgot-password",
    resetPassword: "/reset-password",
    verifyEmail: "/verify-email",
  },
  main: {
    home: "/admission",
    contactUs: "/contact-us",
    studentLife: "/student-life",
    courseDetails: "/course-details/:id/:programTypeId",
    aboutUs: "/about-us",
  },
  dashboard: {
    bioData: "/bio-data",
    workHistory: "/work-history",
    viewWorkHistory: "/view-work-history/:id",
    institute: "/institute",
    viewInstitute: "/view-institute/:id",
    payments: "/payments",
    qualification: "/qualification",
    viewQualification: "/view-qualification/:id",
    dashboard: "/dashboard",
    paymentReceipt: "/payment-receipt",
    applicationStatus: "/application-status",
    applicationForm: "/application-form",
    admissionStatus: "/admission-status",
  },
  onboarding: "/onboarding",
};
